import React from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';

import { ELEVATOR_PAGE, DIMENSIONS_PAGE, PRODUCTS } from '../../navigation/routes';

import styles from './ProgressBar.module.scss';

const cx = classNames.bind(styles);
const STEPS = [
    { label: '1. Aufzug', link: ELEVATOR_PAGE },
    { label: '2. Maße', link: DIMENSIONS_PAGE },
    { label: '3. Produkte', link: PRODUCTS },
]

const getPathWithoutParam = (location) => {
    return location.pathname.slice(0, location.pathname.lastIndexOf('/'))
}

const ProgressBar = () => {
    let location = useLocation();
    let pathname = getPathWithoutParam(location) || location.pathname;


    return (
        <div className={styles.wrapper}>
            {STEPS.map((step, index) => (
                <div className={styles.step} key={`step_${index}`}>
                    <div className={cx('stepText', { 'active': pathname === step.link })}>
                        {step.label}
                    </div>
                    <div className={cx('stepIndicator', { 'active': pathname === step.link })} />
                </div>
            ))}
        </div>
    )
}

export default ProgressBar;